var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "auth-container",
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "h3",
                {
                  staticClass:
                    "text-uppercase mb-1 font-weight-medium oswald-font-family accent--text"
                },
                [_vm._v("\n                    Welcome to\n                ")]
              ),
              _vm._v(" "),
              _c(
                "h1",
                {
                  staticClass:
                    "login-title oswald-font-family text-uppercase mb-10 font-weight-bold",
                  class: [
                    _vm.$vuetify.theme.dark ? "white--text" : "primary--text"
                  ],
                  style: _vm.isMobile ? "font-size: 1.5rem;" : ""
                },
                [_vm._v("\n                    LifeCheq\n                ")]
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "loginForm",
                  staticClass: "text-center",
                  attrs: { "lazy-validation": "" },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.doLogin($event)
                    }
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.doLogin($event)
                    }
                  }
                },
                [
                  _c("v-text-field", {
                    staticClass: "title-branding custom-input",
                    class: _vm.autofilled ? "" : "autofill-input",
                    attrs: {
                      label: "Email",
                      rules: [
                        function(v) {
                          return !!v || "Email is required."
                        },
                        function(v) {
                          return (
                            v.length > 4 ||
                            "Email must be longer than 5 characters"
                          )
                        }
                      ],
                      name: "email",
                      type: "text",
                      filled: "",
                      autocapitalize: "off",
                      autocorrect: "off",
                      disabled: _vm.attempting,
                      placeholder: !_vm.autofilled ? " " : ""
                    },
                    on: { animationstart: _vm.autofillForm },
                    model: {
                      value: _vm.login.email,
                      callback: function($$v) {
                        _vm.$set(_vm.login, "email", $$v)
                      },
                      expression: "login.email"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticClass: "title-branding custom-input",
                    class: _vm.autofilled ? "" : "autofill-input",
                    attrs: {
                      label: "Password",
                      filled: "",
                      name: "password",
                      rules: [
                        function(v) {
                          return !!v || "Password is required."
                        }
                      ],
                      "append-icon": _vm.viewPassword
                        ? "$mdiEye"
                        : "$mdiEyeOff",
                      type: _vm.viewPassword ? "text" : "password",
                      disabled: _vm.attempting,
                      placeholder: !_vm.autofilled ? " " : ""
                    },
                    on: {
                      "click:append": function() {
                        return (_vm.viewPassword = !_vm.viewPassword)
                      }
                    },
                    model: {
                      value: _vm.login.password,
                      callback: function($$v) {
                        _vm.$set(_vm.login, "password", $$v)
                      },
                      expression: "login.password"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-center align-center flex-wrap"
                    },
                    [
                      _c("v-checkbox", {
                        class: _vm.$vuetify.theme.dark
                          ? "white--text"
                          : "primary--text",
                        attrs: {
                          label: "Remember me",
                          value: "1",
                          disabled: _vm.attempting,
                          color: _vm.$vuetify.theme.dark ? "white" : "primary"
                        },
                        model: {
                          value: _vm.login.remember,
                          callback: function($$v) {
                            _vm.$set(_vm.login, "remember", $$v)
                          },
                          expression: "login.remember"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "custom-button",
                          attrs: {
                            type: "submit",
                            color: "secondary",
                            loading: _vm.attempting,
                            small: _vm.isMobile
                          }
                        },
                        [
                          _vm._v(
                            "\n                            Login\n                        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticClass: "mt-3",
                  attrs: { value: _vm.message !== "", color: "error", dark: "" }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.message) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }